import { z } from 'zod';

const URL_SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:\/\//i;

export const withHttpsScheme = (value: string) => {
  const trimmed = value.trim();

  return trimmed === '' || URL_SCHEME_PATTERN.test(trimmed) ? trimmed : `https://${trimmed.replace(/^\/+/, '')}`;
};

/** Takes an address typed without a scheme as https. */
export const webUrlSchema = (error: string) =>
  z
    .string({ error })
    .transform(withHttpsScheme)
    .pipe(z.url({ protocol: /^https?$/, hostname: z.regexes.domain, error }));
